import { render } from "./IndexGerente.vue?vue&type=template&id=e7f21540&scoped=true"
import script from "./IndexGerente.vue?vue&type=script&lang=js"
export * from "./IndexGerente.vue?vue&type=script&lang=js"

import "./IndexGerente.vue?vue&type=style&index=0&id=e7f21540&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7f21540"]])

export default __exports__